<template>
  <div class="my_help">
    <div class="columtitle">帮助中心</div>
    <div class="helplist">
      <div class="hpclitem" v-for="(curent, index) in problemlist" :key="index">
        <div class="dfltit">{{ curent.name1 }}</div>
        <div
          class="chitem"
          v-for="(chitem, chindex) in curent.list"
          :key="chindex"
        >
          <div class="chitemtit" @click="isshowda(chitem)">
            {{ chindex + 1 }}. {{ chitem.name2 }}
          </div>
          <div class="wtdhd" v-show="chitem.hdshow">
            <i class="el-icon-caret-top topjt"></i>
            {{ chitem.cont }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      problemlist: [
        {
          name1: "一、关于个人账号问题：",
          list: [
            {
              name2: "我可以注销账号吗？",
              cont: "（1）您的付费订单有效期为12小时，律师会在订单有效期内回复您的咨询，请您耐心等待。（2）如律师未能在12小时内做出答复，平台 将会在2个工作日内退回您所支付的咨询费用。",
            },
            {
              name2: "绑定手机号为什么显示手机号已注册？",
              cont: "（1）您的付费订单有效期为12小时，律师会在订单有效期内回复您的咨询，请您耐心等待。（2）如律师未能在12小时内做出答复，平台",
            },
          ],
        },
        {
          name1: "二、关于咨询律师问题：",
          list: [
            {
              name2: "付费咨询提交后未得到律师的回复怎么办？",
              cont: "（1）您的付费订单有效期为12小时，律师会在订单有效期内回复您的咨询，请您耐心等待。（2）如律师未能在12小时内做出答复，平台 将会在2个工作日内退回您所支付的咨询费用。",
            },
            {
              name2: "律师付费不满意，如何投诉律师？",
              cont: "（1）您的付费订单有效期为12小时，律师会在订单有效期内回复您的咨询，请您耐心等待。（2）如律师未能在12小时内做出答复，平台",
            },
          ],
        },
      ],
    };
  },
  beforeMount() {
    for (let item of this.problemlist) {
      for (let chitem of item.list) {
        this.$set(chitem,'hdshow',false)
      }
    }
  },
  methods: {
    isshowda(item) {
        item.hdshow = !item.hdshow
    },
  },
};
</script>

<style lang="scss" scoped>
.my_help {
  box-shadow: 1px 1px 6px 0px rgba(0, 0, 0, 0.11);
  .columtitle {
    width: 100%;
    height: 90px;
    line-height: 90px;
    padding-left: 30px;
    background: #f4f4f4;
    font-size: 20px;
    color: #333333;
  }
  .helplist {
    padding: 20px 30px;
    .hpclitem {
      border-top: 1px solid #eee;
      padding-top: 30px;
      margin-top: 30px;
      .dfltit {
        font-size: 16px;
        color: #333333;
        font-weight: 600;
      }
      .chitem {
        cursor: pointer;
        .chitemtit {
          margin-top: 20px;
          font-size: 14px;
          color: #666666;

          &:hover {
            color: #0057ff;
          }
        }
        .wtdhd {
          position: relative;
          padding: 12px;
          line-height: 22px;
          background-color: #f4f4f4;
          font-size: 14px;
          color: #999999;
          margin-top: 20px;
          .topjt {
            position: absolute;
            top: -25px;
            left: 40px;
            color: #f4f4f4;
            font-size: 40px;
          }
        }
      }
      &:first-child {
        border-top: none;
        margin-top: 0;
      }
    }
  }
}
</style>